import { GetApp } from "../../App"
import { GetShip } from "../../App/Context"
import { Block, BlockField, BlockRow } from "../../Components/Block"
import { INoteType } from "../../Types"
import { NoteAttachmentsData } from "../Note/Attachments"
import { NoteViewData } from "../Note/Context"
import { PrintNoteViewProps } from "./Params"

export function PrintNoteView({ cruise: _cruise, day: _day, note, trip: _trip }: PrintNoteViewProps) {
  const app = GetApp();
  const ship = GetShip();
  const tc = app.getT("PrintView");
  const tn = app.getT("NoteView_note");

  // Reference the shared note-type -> field mapping so the "weather notes carry a
  // noteExtra field" rule lives once (Note/Context) instead of being re-hard-coded here.
  const contentFields = NoteViewData.noteContentFields(note.noteType);

  let noteContent;
  switch (note.noteType) {
    case INoteType.weather:
      noteContent = (
        <>
          <BlockRow className="PrintWeatherView">
            <h4>{tc(`note_${INoteType[note.noteType]}`)}: {note.date} {note.title}</h4>
          </BlockRow>
          <BlockRow className="print-weather-note">
            <BlockField label={tn("weather_note")} className="block-field-360">{note.note}</BlockField>
            {contentFields.hasNoteExtra && <BlockField label={tn("weather_note_extra")} className="block-field-360">{note.noteExtra}</BlockField>}
          </BlockRow>
        </>
      );
      break;
    case INoteType.journal:
    case INoteType.technical:
      noteContent = (
        <>
          <h4> {tc(`note_${INoteType[note.noteType]}`)}: {note.date} {note.title}</h4>
          <BlockRow className="print-note-text ">
            {note.note}
          </BlockRow>
        </>
      );
  }

  const attachments = (note.attachments || []).map((a) => {
    const key = `note-${note.id}-attachment-${a.id}`;
    const _label = <span className="attachment-label">{a.fileName}.{a.fileType}</span>;
    const image = NoteAttachmentsData.isImage(a);
    const url = NoteAttachmentsData.attachmentUrl(app.apiClient, ship.id, note.id, a, app.cloudSession());
    return (
      <a key={key} href={url} className="attachment" target="_blank" rel="noopener noreferrer">
        {image && <img src={url} />}
      </a>
    );
  });

  return (
    <Block className="PrintNoteView ">
      {noteContent}
      {attachments}
    </Block>
  );
}
